// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {SvgIconEl} from 'common/components/svg-icon';
import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';
import {SelectEl} from 'common/components/select';

import type {PopoverCard} from './index';

export function template(this: PopoverCard) {
  return (
    <div sel='.mp-popover-card-container'>
      <div sel='.mp-card-header.mp-popover-card-header'>
        <SvgIconEl sel='.svg-title-icon' attrs={{icon: this.attr(`is-segmented`) ? `segment` : `event`}} />
        <div sel='.mp-card-header-title'>
          {this.attr(`title`)}
          <div sel='.mp-card-header-subtitle'>{this.attr(`subtitle`)}</div>
        </div>
        <ButtonEl
          sel='.mp-card-header-close'
          attrs={{
            theme: ButtonTheme.Tertiary,
            icon: `x`,
          }}
          on={{click: this.helpers.handleClose}}
        />
      </div>
      <div sel='.body'>
        <slot />
      </div>
      <div sel='.footer'>
        <slot attrs={{name: `footer`}} />
        {this.helpers.getMainOptions().map((buttonOption: any) => (
          <div sel='.button-option-container'>
            {!buttonOption.values ? (
              <>
                <ButtonEl
                  attrs={{
                    theme: ButtonTheme.Secondary,
                    icon: buttonOption.icon,
                    disabled: buttonOption.isDisabled,
                    ...(buttonOption.tooltip
                      ? {
                          tooltip: {
                            'max-width': `250px`,
                            text: buttonOption.tooltip,
                          },
                        }
                      : {}),
                  }}
                  on={{
                    click: this.helpers.handleSelect(buttonOption),
                    mouseover: this.helpers.handleFocusItem(buttonOption),
                    mouseout: this.helpers.handleUnfocusItem,
                    disabled: buttonOption.disabled,
                  }}
                >
                  <span sel='.button-label'>{buttonOption.label}</span>
                </ButtonEl>
              </>
            ) : buttonOption.values ? (
              <>
                <SelectEl
                  attrs={{
                    'selected-option': buttonOption.label,
                    disabled: buttonOption.isDisabled,
                    ...(buttonOption.tooltip
                      ? {
                          tooltip: {
                            'max-width': `250px`,
                            text: buttonOption.tooltip,
                          },
                        }
                      : {}),
                  }}
                  props={{
                    sections: [{items: buttonOption.values}],
                  }}
                  on={{
                    change: this.helpers.handleChange,
                    focusItem: this.helpers.handleFocusItem(buttonOption),
                    menuChange: this.helpers.handleUnfocusItem,
                  }}
                />
              </>
            ) : null}
          </div>
        ))}
        {this.helpers.hasOverflow() ? (
          <div sel='.button-option-container'>
            <SelectEl
              attrs={{
                icon: {leftIcon: `hor-ellipsis`},
              }}
              props={{
                sections: [{items: this.helpers.getOverflowOptions()}],
              }}
              on={{change: this.helpers.handleChange}}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}
